import {
  TemplateRef,
  ElementRef,
} from '@angular/core';

import { Directive } from '@angular/core';

@Directive({
  selector: '[dropdownTrigger]',
  standalone: true,
})
export class DropdownTriggerDirective {
  constructor(public el: ElementRef<HTMLElement>) {}
}

@Directive({
  selector: '[dropdownPanel]',
  standalone: true,
})
export class DropdownPanelDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
